import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { loading, isAuthenticated, painelUrl } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-amber-50">
        <div className="text-center">
          <div className="w-12 h-12 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <h2 className="text-lg font-semibold text-gray-700 mb-2">Verificando acesso...</h2>
          <p className="text-gray-500">Aguarde um momento</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    // Redirecionar para o painel administrativo para fazer login
    window.location.href = `${painelUrl}/login?redirect=${encodeURIComponent(window.location.href)}`;
    return null;
  }

  return children;
};

export default ProtectedRoute;
